// src/api/constants.js
export const ROLES = {
  ADMIN: "Administrator",
  TENANT_ADMIN: "TenantAdmin",
  USER: "User",
};
export const ROLE_ROUTES = {
  [ROLES.ADMIN]: "/admin/dashboard",
  [ROLES.TENANT_ADMIN]: "/user/dashboard",
  [ROLES.USER]: "/user/dashboard", // User role now uses same dashboard as TenantAdmin (permission-controlled)
};

export const PUBLIC_ROUTES = [
  "/login",
  "/verify",
  "/forgot-password",
  "/reset-password",
  "/access-denied",
  "/policy",
  "/kvkk",
  "/",
];

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "https://kuppion-server.azurewebsites.net",
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  HEADERS: {
    "Content-Type": "application/json",
  },
  SUBTENANTS: {
    READ: 'permission.subTenants.read',
    WRITE: 'permission.subTenants.write',
    CREATE: 'permission.subTenants.create',
    UPDATE: 'permission.subTenants.update',
    DELETE: 'permission.subTenants.delete'
  },
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "production",
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === "true",
};

export const AUTH_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  REFRESH_TOKEN_EXPIRY: "refreshTokenExpiry",
  EMAIL: "email",
  USER: "user",
  TOKEN_EXPIRY: "tokenExpiry",
  LAST_ACTIVITY: "lastActivity",
  // Keys for verification page
  VERIFICATION_END_TIME: "verificationEndTime",
  VERIFICATION_MAX_TIME: "verificationMaxTime",
  VERIFICATION_ORIGINAL_MAX_TIME: "verificationOriginalMaxTime",
  LAST_CODE_REQUEST_TIME: "lastCodeRequestTime",
  AUTO_RESEND_COUNT: "autoResendCount",
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER: 500,
};

// Session timeout settings (in milliseconds)
export const SESSION = {
  INACTIVITY_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 minutes before expiry
  MAX_VERIFICATION_TIME: 180, // 3 minutes for verification code
};

export const MESSAGES = {
  SUCCESS: {
    LOGIN: "Doğrulama kodu gönderildi.",
    VERIFY: "Giriş başarılı.",
    LOGOUT: "Başarıyla çıkış yapıldı.",
    DATA_FETCHED: "Veriler başarıyla getirildi.",
    DATA_UPDATED: "Veriler başarıyla güncellendi.",
    DATA_DELETED: "Veriler başarıyla silindi.",
  },
  ERROR: {
    DEFAULT: "Bir hata oluştu.",
    LOGIN: "Kod gönderilirken hata oluştu.",
    VERIFICATION: "Doğrulama kodu hatalı.",
    LOGOUT: "Çıkış yapılırken hata oluştu.",
    TOKEN_EXPIRED: "Oturumunuz sona erdi. Lütfen tekrar giriş yapın.",
    NETWORK: "Ağ bağlantısı hatası.",
    SERVER: "Sunucu hatası oluştu.",
    VALIDATION: "Geçersiz veri formatı.",
    NOT_FOUND: "İstenilen kayıt bulunamadı.",
    UNAUTHORIZED: "Bu işlem için yetkiniz yok.",
    FORBIDDEN: "Bu işlemi yapmaya yetkiniz yok.",
    SESSION_EXPIRED:
      "Oturumunuz zaman aşımına uğradı. Lütfen tekrar giriş yapın.",
    REFRESH_FAILED:
      "Oturum yenilenirken hata oluştu. Lütfen tekrar giriş yapın.",
  },
};

export const TOAST_CONFIG = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  className: "toast-container",
};

// Centralized Permission Constants - Single Source of Truth
export const PERMISSIONS = {
  DASHBOARD: {
    READ: 'permission.dashboard.read',
    WRITE: 'permission.dashboard.write', 
    CREATE: 'permission.dashboard.create',
    UPDATE: 'permission.dashboard.update',
    DELETE: 'permission.dashboard.delete'
  },
   CAMPAIGNS: {
    READ: 'permission.campaigns.read',
    WRITE: 'permission.campaigns.write',
    CREATE: 'permission.campaigns.create',
    UPDATE: 'permission.campaigns.update',
    DELETE: 'permission.campaigns.delete'
  },
  DRAWS: {
    READ: 'permission.draws.read',
    WRITE: 'permission.draws.write',
    CREATE: 'permission.draws.create',
    UPDATE: 'permission.draws.update',
    DELETE: 'permission.draws.delete'
  },
  SURVEYS: {
    READ: 'permission.surveys.read',
    WRITE: 'permission.surveys.write',
    CREATE: 'permission.surveys.create',
    UPDATE: 'permission.surveys.update',
    DELETE: 'permission.surveys.delete'
  },
  ANNOUNCEMENTS: {
    READ: 'permission.announcements.read',
    WRITE: 'permission.announcements.write',
    CREATE: 'permission.announcements.create',
    UPDATE: 'permission.announcements.update',
    DELETE: 'permission.announcements.delete'
  },
  REPORTS: {
    READ: 'permission.reports.read',
    WRITE: 'permission.reports.write'
  },
  TICKETS: {
    READ: 'permission.tickets.read',
    WRITE: 'permission.tickets.write'
  },
  VIDEOS: {
    READ: 'permission.videos.read',
    WRITE: 'permission.videos.write',
    CREATE: 'permission.videos.create',
    UPDATE: 'permission.videos.update',
    DELETE: 'permission.videos.delete'
  },
  COMPANIES: {
    READ: 'permission.companies.read',
    WRITE: 'permission.companies.write',
    CREATE: 'permission.companies.create',
    UPDATE: 'permission.companies.update',
    DELETE: 'permission.companies.delete'
  }, 

  PAYMENTS: {
    READ: 'permission.payments.read',
    WRITE: 'permission.payments.write',
    CREATE: 'permission.payments.create',
    UPDATE: 'permission.payments.update',
    DELETE: 'permission.payments.delete'
  },
  GIFTS: {
    READ: 'permission.gifts.read',
    WRITE: 'permission.gifts.write',
    CREATE: 'permission.gifts.create',
    UPDATE: 'permission.gifts.update',
    DELETE: 'permission.gifts.delete'
  },
  USERS: {
    READ: 'permission.users.read',
    WRITE: 'permission.users.write',
    CREATE: 'permission.users.create',
    UPDATE: 'permission.users.update',
    DELETE: 'permission.users.delete'
  },
  BRANDS: {
    READ: 'permission.brands.read',
    WRITE: 'permission.brands.write',
    CREATE: 'permission.brands.create',
    UPDATE: 'permission.brands.update',
    DELETE: 'permission.brands.delete'
  },
  SUBTENANTS: {
    READ: 'permission.subTenants.read',
    WRITE: 'permission.subTenants.write',
    CREATE: 'permission.subTenants.create',
    UPDATE: 'permission.subTenants.update',
    DELETE: 'permission.subTenants.delete'
  }
};

// Module Names Constants
export const MODULES = {
  CAMPAIGNS: 'campaigns',
  DRAWS: 'draws',
  SURVEYS: 'surveys',
  ANNOUNCEMENTS: 'announcements',
  USERS: 'users',
  REPORTS: 'reports',
  TICKETS: 'tickets',
  COMPANIES: 'companies',
  PAYMENTS: 'payments',
  GIFTS: 'gifts',
  DASHBOARD: 'dashboard',
  BRANDS: 'brands',
  VIDEOS: 'videos',
  SUBTENANTS: 'subTenants'
};